import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <RankingSection />
        <AboutSection />
        <ContactSection />
        <CarouselSection />
        <AppSection />
        <IndexSection />
        <MediaSection />
        <FAQSection />
        <CardsSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}